module.exports = __webpack_public_path__ + "static/media/presentation-des-modules.f585e6b1.jpg";